import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-generic-pagination',
  templateUrl: './generic-pagination.component.html',
  styleUrls: ['./generic-pagination.component.css']
})
export class GenericPaginationComponent {

  isFirstPage: boolean;
  isLastPage: boolean;
  currentPage: number;
  totalPages: number;
  pages: number[]; 

  @Input('totalPages')
  set _totalPages(value: number[]) {
    this.totalPages = value?.length ? value?.length : 0;
    this.pages = value;
  }

  @Input('currentPage')
  set _currentPage(value: number) {
    this.currentPage = value;
    this.isFirstPage = (value === 1) ? true : false;
  }

  @Input('endPage')
  set _endPage(value: boolean) {
    this.isLastPage = value;
  }

  @Output() paginateChange = new Subject<number>();

  constructor() { }

  onPaginateChange(value: number) {
    this.paginateChange.next(value);  
  }
}
